/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IChallengeClip } from '../challenge-clip-schema';
import { challengeClipSchema } from '../challenge-clip-schema';

export const createChallengeClipResponseSchema = createApiResponseSchema(
  challengeClipSchema,
) as import('zod').ZodSchema<IAPI<IChallengeClip>>;

export type ICreateChallengeClipResponse = IAPI<IChallengeClip>;
